import InputAndSelect from "../../../../../components/common/InputAndSelect";
import { capitalizeCurrencyCode } from "../../../../../utils/helpers";
import { Link, useParams } from "react-router-dom";
import { ContentWrapper } from "./styles";
import CustomSelect from "../../../../../components/common/CustomSelect";
import { RateBox } from "../styles";
import {
  formatCurrencyAmount,
} from "../../../../../utils/currency";
import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { BalanceExceptionWrapper } from "../../../Wallet/ChinaPayoutV2/styles";
import { ReactComponent as NotifyIcon } from "../../../assets/notify-icon.svg";
import { Button } from "../../../../../components/common/Button";
import { Controller, useForm } from "react-hook-form";
import { getRefundsFee } from "../../../../Refunds/redux/actions";
import { debounce } from "lodash";
import Loader from "../../../../../components/common/Loader";
import { getExchangeRate, getmomoTransferFee } from "../../../redux/slice";
import { savedPayoutData } from "../../../redux/formDataSlice";
import {
  PAWA_PAY_PAYMENT_METHODS,
  PAWA_PAY_PAYMENT_OPTIONS_BY_CURRENCY,
} from "../../../const";

type Props = {
  handleNext?: () => void;
  handlePrevious?: () => void;
};

type WalletProps = {
  currency: string;
};

type UserData = {
  amount: number;
  currency: string;
  walletId: string;
  walletType: string;
  paymentMethod?: string;
  operator?: string;
  rate?: number | null;
  fee?: number | null;
  balanceError?: boolean;
  totalAmount?: number;
  convertedAmount?: number;
};

type FormData = Pick<UserData, "amount" | "paymentMethod"> & {
  secondaryPaymentMethod: string;
};

const Amount = ({ handleNext }: Props) => {
  const { currencyCode, country } = useParams();
  const { wallets, loading } = useAppSelector((state) => state?.wallets || {});
  const getSavedData = useAppSelector((state) => state.formData.intPayoutData);
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<FormData>() || {};

  const INT_FORM_DATA = useAppSelector(
    (state) => state.formData?.intPayoutData || {},
  );
  const [userData, setUserData] = useState<UserData>(INT_FORM_DATA);

  const dispatch = useAppDispatch();

  const filteredWallets = wallets as WalletProps[];

  const uniqueCurrencies = Array.from(
    new Set(filteredWallets?.map((wallet) => wallet.currency)),
  );

  const options = uniqueCurrencies.map((currency) => ({
    label: currency,
    value: currency,
  }));
  const walletToDebit = options?.filter((option) => option.value === "USD");
  const CURRENT_WALLET = wallets?.find((wallet) => wallet.currency === "USD");

  const debounceFee = useCallback(
      debounce((amount: number) => {
        dispatch(
            getmomoTransferFee({
              currency: capitalizeCurrencyCode(currencyCode),
              amount,
            }),
        )
            .then((momoTransferFee) => {
              if (getRefundsFee.fulfilled.match(momoTransferFee)) {
                const { data } = momoTransferFee.payload;

                dispatch(
                    getExchangeRate({
                      destinationCurrency: "USD",
                      sourceCurrency: capitalizeCurrencyCode(currencyCode),
                      amount,
                    }),
                ).then((exchangeRateResponse) => {
                  const exchangeRate =
                      exchangeRateResponse?.payload?.data?.rate ?? 1;
                  const convertedAmount =
                      exchangeRateResponse?.payload?.data?.amount ?? 0;
                  const fee = Number(data?.fee ?? 0);

                  setUserData((prevData) => {
                    const totalAmount = parseFloat(
                        (convertedAmount).toFixed(2)
                    ) + parseFloat(fee.toFixed(2));

                    return {
                      ...prevData,
                      fee,
                      rate: Number(exchangeRate),
                      convertedAmount,
                      totalAmount,
                    };
                  });
                });
              }
            })
            .catch((r) => r);
      }, 2000),
      [dispatch, currencyCode],
  );


  useEffect(() => {
    if (userData.amount) {
      debounceFee(userData.amount);
    } else {
      setUserData((prevData) => ({
        ...prevData,
        totalAmount: null,
        fee: null,
      }));
    }
  }, [debounceFee, userData.amount]);

  useEffect(() => {
    if (userData.totalAmount > Number(CURRENT_WALLET?.availableBalance || 0)) {
      setUserData((prevData) => ({
        ...prevData,
        balanceError: true,
      }));
    }

    else {
        setUserData((prevData) => ({
            ...prevData,
            balanceError: false,
        }));
    }
  }, [CURRENT_WALLET, userData.totalAmount]);

  useEffect(() => {
    if (getSavedData) {
      Object.keys(getSavedData).forEach((key) => {
        setValue(key as keyof FormData, getSavedData[key as keyof FormData]);
      });
    }
  }, [getSavedData, setValue]);

  const handleAmountChange = (enteredAmount: number) => {
    setUserData((prevData) => ({
      ...prevData,
      amount: enteredAmount,
    }));
  };

    const handleNextStep = useCallback(() => {
        handleSubmit((formValues: Record<string, any>) => {
            const combinedData = { ...userData, ...formValues, totalAmount: userData.totalAmount };
            dispatch(savedPayoutData(combinedData));
            handleNext();
        })();
    }, [userData, dispatch]);

    const getPaymentOptions = (country) => {
        return PAWA_PAY_PAYMENT_OPTIONS_BY_CURRENCY[country] || [];
    };

  const getPaymentChannels = (country) => {
    return PAWA_PAY_PAYMENT_METHODS[country] || [];
  };

    return (
    <ContentWrapper>
      <Loader isLoading={loading} />
      <Controller
        name="amount"
        rules={{ required: "Field is required" }}
        control={control}
        render={({ field }) => (
          <div>
            <InputAndSelect
              amountValue={userData.amount}
              onAmountChange={(value) => {
                field.onChange(value);
                handleAmountChange(value as number);
              }}
              width="100%"
              placeholder="Amount"
              options={[
                {
                  label: capitalizeCurrencyCode(currencyCode),
                  value: capitalizeCurrencyCode(currencyCode),
                },
              ]}
              selectValue={capitalizeCurrencyCode(currencyCode)}
            />
            <span className="error">{errors?.amount?.message}</span>
          </div>
        )}
      />

      <div>
        <Controller
          name="paymentMethod"
          control={control}
          rules={{ required: false }}
          render={({ field }) => {
            return (
              <CustomSelect
                {...field}
                defaultValue={"Mobile money"}
                // options={getPaymentChannels(country)}
                $width="100%"
                placeholder="Mobile money"
                disabled
                lightBorder

              />
            );
          }}
        />
      </div>

      <div>
        <Controller
          name="secondaryPaymentMethod"
          control={control}
          rules={{ required: "Secondary payment method is required" }}
          render={({ field }) => {
            return (
              <CustomSelect
                {...field}
                options={getPaymentOptions(country)}
                $width="100%"
                placeholder="Select mobile operator network"
                lightBorder
              />
            );
          }}
        />
        <span className="error">{errors?.secondaryPaymentMethod?.message}</span>
      </div>

      <section>
        <RateBox>
          <span className="fee-box">
            x
            <span>{formatCurrencyAmount("", userData?.rate ?? 0, 5) ?? 0}</span>
          </span>
          <span>Exchange rate</span>
        </RateBox>
      </section>

      <section>
        <RateBox>
          <span className="fee-box">
            +<span>{formatCurrencyAmount("", userData?.fee ?? 0, 2) ?? 0}</span>
          </span>
          <span>Fees</span>
        </RateBox>
      </section>

      <div>
        <InputAndSelect
          amountValue={userData?.totalAmount?.toFixed(2)}
          width="100%"
          placeholder="Total you will be charged"
          options={walletToDebit}
          selectValue={"USD"}
        />
        {userData?.balanceError && (
          <BalanceExceptionWrapper>
            <NotifyIcon /> <span>Exceeds your wallet balance.</span>
            <Link to="/wallets/usd"> Top-up funds</Link>
          </BalanceExceptionWrapper>
        )}
      </div>

      <Button
        height="48px"
        label="Continue"
        disabled={userData.balanceError || loading}
        onClick={handleSubmit(handleNextStep)}
      />
    </ContentWrapper>
  );
};

export default Amount;
